import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { has_Permission } from '../../helpers/jwt-token-access/accessToken'

//i18n
import { withNamespaces } from 'react-i18next';

import { connect } from "react-redux";
import {
    changeLayout,
    changeLayoutWidth,
    changeSidebarTheme,
    changeSidebarType,
    changePreloader
} from "../../store/actions";

class SidebarContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    componentDidMount() {
        if (localStorage.getItem("authUser")) {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            this.setState({ user: obj.user  })
          }
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {

            if (this.props.type !== prevProps.type) {
                this.initMenu();
            }
        }
    }

    initMenu() {
        new MetisMenu("#side-menu");

        var matchingMenuItem = null;
        var ul = document.getElementById("side-menu");
        var items = ul.getElementsByTagName("a");
        for (var i = 0; i < items.length; ++i) {
            if (this.props.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;
                    if (parent4) {
                        parent4.classList.add("mm-active");
                    }
                }
            }
            return false;
        }
        return false;
    };

    render() {
        const { user } = this.state
 
        return (
            <React.Fragment>
                <div id="sidebar-menu">

                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">{this.props.t('Menu')}</li>

                        <li>
                            <Link to="/dashboard" className="waves-effect">
                                <i className="ri-dashboard-line"></i>
                                <span className="ms-1">{this.props.t('Dashboard')}</span>
                            </Link>
                        </li>
                        {has_Permission(user, 7, 'read' )?<li>
                            <Link to="/#" className="has-arrow waves-effect">
                                <i className="fas fa-map-signs"></i>
                                <span className="ms-1">{this.props.t('Itineraries')}</span>
                            </Link>
                            <ul className="sub-menu">
                            {has_Permission(user, 0, 'read' )?
                                <li><Link to="/itineraries">{this.props.t('Itineraries')}</Link></li>
                            :null}
                             {has_Permission(user, 7, 'read' )?
                                <li><Link to="/itinerary-payments">{this.props.t('Payments')}</Link></li>
                            :null}
                            
                            </ul>
                        </li>:
                        has_Permission(user, 0, 'read' )?
                            <li>
                            <Link to="/itineraries" className="waves-effect">
                                <i className="fas fa-map-signs"></i>
                                <span className="ms-1">{this.props.t('Itineraries')}</span>
                            </Link>
                        </li>
                        :""}
                        {has_Permission(user, 1, 'read' )?

                        <li>
                            <Link to="/locations" className="waves-effect">
                                <i className="ri-road-map-fill"></i>
                                <span className="ms-1">{this.props.t('Locations')}</span>
                            </Link>
                        </li>
                        :""}
                        {has_Permission(user, 2, 'read' )?
                        <li>
                            <Link to="/vehicles" className="waves-effect">
                                <i className="fas fa-car"></i>
                                <span className="ms-1">{this.props.t('Vehicles')}</span>
                            </Link>
                        </li>
                        :null}
                        {has_Permission(user, 3, 'read' )?
                        <li>
                            <Link to="/hotels" className="waves-effect">
                                <i className="fas fa-hotel"></i>
                                <span className="ms-1">{this.props.t('Hotels')}</span>
                            </Link>
                        </li>
                        :null}
                        {has_Permission(user, 4, 'read' )?
                        <li>
                            <Link to="/activities" className="waves-effect">
                                <i className="fas fa-skiing"></i>
                                <span className="ms-1">{this.props.t('Activities')}</span>
                            </Link>
                        </li>
                        :null}
                        <li>
                            <Link to="/#" className="has-arrow waves-effect">
                                <i className="fas fa-file-contract"></i>
                                <span className="ms-1">{this.props.t('CMS')}</span>
                            </Link>
                            <ul className="sub-menu">
                            {has_Permission(user, 5, 'read' )?
                                <li><Link to="/terms-and-conditions">{this.props.t('Terms & Conditions')}</Link></li>
                            :null}
                             {has_Permission(user, 6, 'read' )?
                                <li><Link to="/inclusitions-exclusitions">{this.props.t('Inclusitions Exclusitions')}</Link></li>
                            :null}
                             {has_Permission(user, 7, 'read' )?
                                <li><Link to="/payments">{this.props.t('Payments')}</Link></li>
                            :null}
                             {has_Permission(user, 8, 'read' )?
                                <li><Link to="/signatures">{this.props.t('Signatures')}</Link></li>
                            :null}
                            </ul>
                        </li>
                        { has_Permission(user, 10, 'read' )? (
                            <li>
                                <Link to="/users" className="waves-effect">
                                <i className="fas fa-users"></i>
                                <span className="ms-1">{this.props.t('Users')}</span>
                                </Link>
                            </li>
                            ):null}
                            {has_Permission(user, 9, 'read' ) || has_Permission(user, 11, 'read' ) ?
                            <li>
                               
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="fas fa-cogs"></i>
                                    <span className="ms-1">{this.props.t('Settings')}</span>
                                </Link>
                                <ul className="sub-menu">
                                    <li><Link to="/signatures">{this.props.t('Signatures')}</Link></li>
                                {/* {has_Permission(user, 9, 'read' )? (
                                    <li><Link to="/manage-countries">{this.props.t('Manage Countries')}</Link></li>
                                ):null} */}
                                
                                </ul>
                            </li>
                            :null}

                    </ul>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return { ...state.Layout };
};

export default withRouter(connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader
})(withNamespaces()(SidebarContent)));
